module.exports = __webpack_public_path__ + "static/8-09349343cae4a3543dfab237fcf04079.jpg";